import { render } from "./index.vue?vue&type=template&id=67b26ea2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=67b26ea2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b26ea2"],['__file',"src/components/BaseUi/FormInput/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67b26ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67b26ea2', __exports__)) {
    api.reload('67b26ea2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=67b26ea2&scoped=true", () => {
    api.rerender('67b26ea2', render)
  })

}


export default __exports__